import { defineStore } from 'pinia'
import { ref } from 'vue'
import { formatAppTexts } from '~/utils/text'
import type { CmsText } from '~/server/db/schema'
import type { NuxtResponse } from '~/shared/api/dto'

export const useAppTextsStore = defineStore('appTexts', () => {
	const texts = ref<Record<string, string> | null>(null)
	const isLoading = ref(false)
	const error = ref<string | null>(null)

	if (import.meta.server) {
		const nuxtApp = useNuxtApp()
		texts.value = nuxtApp.ssrContext?.event.context.texts || null
	} else {
		texts.value = window.__INITIAL_TEXTS__ || null
	}

	async function fetchAppTexts() {
		if (texts.value) return
		try {
			isLoading.value = true
			error.value = null
			const response = await $fetch<NuxtResponse<CmsText[]>>('/api/cms/texts')
			texts.value = formatAppTexts(response.data)
		} catch (err) {
			error.value = (err as Error).message
		} finally {
			isLoading.value = false
		}
	}

	return {
		texts,
		isLoading,
		error,
		fetchAppTexts,
	}
})
